import { render, staticRenderFns } from "./merchandise.vue?vue&type=template&id=1fcc1ad0"
import script from "./merchandise.vue?vue&type=script&lang=js"
export * from "./merchandise.vue?vue&type=script&lang=js"
import style0 from "./merchandise.vue?vue&type=style&index=0&id=1fcc1ad0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports